
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_faq';
const tableOfContents = [];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{` 1. Do you offer white-label apps for the Drivers? `}</strong>{`
Yes, it is possible. This involves a setup fee based on the level of customisation and maintenance fee for monthly app deployments.`}</p>
    <p><strong parentName="p">{` 2. Do you sell the source code of the delivery app where we can customise as per our need?  `}</strong>{`
Yes, Tradly sell source code of the front end apps. The price varies based on type of licence (Single brand or multi brand).`}</p>
    <p><strong parentName="p">{`3. Do you offer multi-language options?  `}</strong>{`
All our existing apps used to String translation. We have not implemented that in the delivery app. It might be available soon based on demand. For now, everything is English. `}</p>
    <p><strong parentName="p">{`4. Can we develop our own delivery app using your API? `}</strong>{`
Yes, you can deliver your own mobile application. Tradly provides API-reference and open API access to platform owners. `}</p>
    <p><strong parentName="p">{`5. What does the freemium version provides?  `}</strong>{`
The freemium version provides everything we almost sell in all other packages. You pay based on the usage of the platform. `}</p>
    <p><strong parentName="p">{`6. How do you calculate the cost of your pricing?  `}</strong>{`
Tradly use two variables. One is our COGS where we need to pay for MAP services, Server/hosting and all other infrastructure cost. Two is our human resource support. If clients need more of a human resource support, that means we need to hire/have more people to support our client, So we charge you for that. If you rely on community support, that’s where you pay ONLY for the usage of the platform. Optionally, we charge in custom and package-based variation based on size of the company requirements. Bigger companies expect different set of features comparing a restaurant chain / boutique stores. `}</p>
    <p><strong parentName="p">{`7. Do I require credit card to test? `}</strong>{`
No, you don’t need a credit card to start. However, we do ask your credit card after 30 days.  So, we can charge for the orders after 100+ free limit. `}</p>
    <p><strong parentName="p">{`8. Do I need to buy & use your other products (like commerce, marketplace) to use the Fleet product? `}</strong>{`
No, you don’t need. You can connect with other systems like Shopify, Woo-commerce, or your POS systems. `}</p>
    <p><strong parentName="p">{`9. How do I connect to my existing Shopify? `}</strong>{`
We are in the midst of completing our integrations with Shopify. Once finished, without any code integrations, you can connect using Tradly Fleet App on Shopify. Every new order coming from Shopify will send to Tradly Fleet. And hence your drivers would receive the orders to be shipped, delivered, etc. `}</p>
    <p><strong parentName="p">{`10. How long does it take to Set up the system?`}</strong>{`
Our SuperAdmin panel is handy that directs you how to set up to start the operation. It’s simple to add your store, fleet, and drivers. That’s it. The only challenge would be connecting with your order system. `}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
